import styled, { css } from 'styled-components'
import { setBorderMixinAfter, setBorderMixinBefore } from 'styles/mixins'
import { COLORS } from 'consts/colors'
import { RADII, SHADOWS } from 'styles/consts'
import { SMALL_DESKTOP_SIZE_BREAKPOINT } from 'consts'

export const MusicVersionWrapper = styled.div<{
  $isSelected: boolean
}>`
  min-height: 40px;
  display: flex;
  align-items: center;
  padding: 0 8px 0 12px;
  position: relative;
  justify-content: space-between;
  position: relative;

  border-radius: ${RADII.item};
  ${props => {
    if (props.$isSelected) {
      return css`
        ${setBorderMixinBefore({
          color: COLORS.primaryDark,
          size: 1,
          borderRadius: RADII.item
        })}
        background: ${COLORS.primaryLight};
        box-shadow: ${SHADOWS.card};
      `
    } else {
      return css`
        ${setBorderMixinBefore({
          color: COLORS.borderColor,
          size: 1,
          borderRadius: RADII.item
        })}

        cursor: pointer;

        &:hover {
          ${setBorderMixinAfter({
            color: COLORS.primaryDark,
            size: 1,
            borderRadius: RADII.item
          })}
        }

        @media only screen and (max-width: ${SMALL_DESKTOP_SIZE_BREAKPOINT}px) {
          &::after {
            display: none;
          }
        }
      `
    }
  }}
`

export const MusicVersionLeftBox = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`
